export default {output:'OUTPUT'};